export function getCountryCodeFromCurrency(currency) {
  const countryCodes = {
    USD: 'US',
    CAD: 'CA',
    GBP: 'GB',
    EUR: 'EU',
    AUD: 'AU',
  };

  return countryCodes[currency.toUpperCase()] || 'US';
}
